import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-help-content',
  templateUrl: './help-content.component.html',
  styleUrls: ['./help-popover.component.scss'],
})
export class HelpContentComponent {
  @Input() text: string;

  constructor() {}
}
